import { IBackgroundJobExtendedInfo } from './IBackgroundJobExtendedInfo';
import { IGetItemsResult } from '../../ts/ServerApi/types/IGetItemsResult';
import { Request } from '../../ts/ServerApi/requests/Request';

export interface IGetBackgroundJobExtendedInfoParams {
  backgroundJobId: string;
}

export interface IGetBackgroundJobExtendedInfoResult extends IGetItemsResult, IBackgroundJobExtendedInfo {}

export class GetBackgroundJobExtendedInfoRequest extends Request<IGetBackgroundJobExtendedInfoParams, IGetBackgroundJobExtendedInfoResult> {
  constructor(params: IGetBackgroundJobExtendedInfoParams) {
    super('getBackgroundJobExtendedInfo', params);
  }
}
